// Import all markdown files statically
import coreConceptsContent from './core-concepts.md';
import featureFlagsContent from './feature-flags.md';
import permissionsContent from './permissions.md';
import manageSolutionsContent from './manage-solutions.md';
import stepUpProcessContent from './step-up-process.md';

// Map article IDs to their imported markdown content
// NOTE: When adding a new article:
// 1. Add the .md file to this directory
// 2. Import it above (e.g., import myNewArticle from './my-new-article.md')
// 3. Add to this map with the article ID from index.json
// 4. Update index.json with the new article metadata
export const articleContentMap: Record<string, string> = {
  'core-concepts': coreConceptsContent,
  'feature-flags': featureFlagsContent,
  permissions: permissionsContent,
  'manage-solutions': manageSolutionsContent,
  'step-up-process': stepUpProcessContent,
};

// Export the metadata separately
export { default as articlesMetadata } from './index.json';
